import { render, staticRenderFns } from "./ContactQueries.vue?vue&type=template&id=b19f8596&scoped=true"
import script from "./ContactQueries.vue?vue&type=script&lang=js"
export * from "./ContactQueries.vue?vue&type=script&lang=js"
import style0 from "./ContactQueries.vue?vue&type=style&index=0&id=b19f8596&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b19f8596",
  null
  
)

export default component.exports